import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const MedicalGeneticsIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.0713 40C80.0713 61.8153 62.3865 79.5 40.5713 79.5C18.756 79.5 1.07129 61.8153 1.07129 40C1.07129 18.1848 18.756 0.5 40.5713 0.5C62.3865 0.5 80.0713 18.1848 80.0713 40Z'
    />
    <g clipPath='url(#clip0_414_17709)'>
      <path
        d='M42.7406 49.8576C42.5475 49.8576 42.3541 49.784 42.2065 49.6363L30.7353 38.1651C30.4404 37.8703 30.4404 37.3919 30.7353 37.0966C31.0306 36.8018 31.5089 36.8018 31.8038 37.0966L43.275 48.5678C43.5699 48.8627 43.5699 49.3414 43.275 49.6363C43.1274 49.784 42.934 49.8576 42.7406 49.8576Z'
        fill='#8AC129'
      />
      <path
        d='M47.6287 47.911C47.4353 47.911 47.2419 47.837 47.0946 47.6897L32.7117 33.3068C32.4164 33.0119 32.4164 32.5332 32.7117 32.2383C33.0066 31.943 33.4853 31.943 33.7802 32.2383L48.1631 46.6208C48.458 46.9161 48.458 47.3945 48.1631 47.6897C48.0155 47.837 47.8221 47.911 47.6287 47.911Z'
        fill='#FF4C4C'
      />
      <path
        d='M49.5759 43.0224C49.3825 43.0224 49.1891 42.9488 49.0415 42.8012L37.5703 31.33C37.2754 31.0351 37.2754 30.5564 37.5703 30.2615C37.8655 29.9662 38.3439 29.9662 38.6392 30.2615L50.11 41.7323C50.4052 42.0275 50.4052 42.5059 50.11 42.8012C49.9623 42.9488 49.7689 43.0224 49.5759 43.0224Z'
        fill='#8AC129'
      />
      <path
        d='M61.0901 31.0733C60.8967 31.0733 60.7037 30.9996 60.5561 30.852L49.6323 19.9286C49.3374 19.6334 49.3374 19.155 49.6323 18.8601C49.9275 18.5649 50.4059 18.5649 50.7012 18.8601L61.6246 29.7835C61.9198 30.0788 61.9198 30.5571 61.6246 30.852C61.4769 30.9996 61.2835 31.0733 61.0901 31.0733Z'
        fill='#FF4C4C'
      />
      <path
        d='M30.7917 61.3722C30.5983 61.3722 30.4049 61.2986 30.2572 61.1509L19.3335 50.2272C19.0386 49.9323 19.0386 49.4539 19.3335 49.1587C19.6287 48.8638 20.1071 48.8638 20.4023 49.1587L31.3261 60.0824C31.621 60.3773 31.621 60.8561 31.3261 61.1509C31.1785 61.2986 30.9851 61.3722 30.7917 61.3722Z'
        fill='#FF4C4C'
      />
      <path
        d='M29.3722 46.7197C24.7197 45.84 19.8774 45.7 15.9616 49.6154C15.3112 50.2662 15.3108 51.321 15.9616 51.9717C16.6124 52.6225 17.6671 52.6222 18.3179 51.9717C21.4929 48.7968 25.5342 49.2625 30.1874 50.286C29.9238 49.0871 29.6338 47.8927 29.3722 46.7197Z'
        fill='#FFBF14'
      />
      <path
        d='M29.3722 46.7195C28.6791 46.5883 27.9818 46.4738 27.2837 46.3865C27.5362 47.5404 27.8128 48.681 28.0787 49.8632C28.7665 49.9834 29.4699 50.1279 30.1874 50.2859C29.9223 49.0804 29.6347 47.896 29.3722 46.7195Z'
        fill='#E0A812'
      />
      <path
        d='M52.4454 17.8443C53.0962 17.1935 53.0962 16.1387 52.4454 15.4879C51.795 14.8372 50.7398 14.8375 50.0894 15.4879C40.798 24.7794 54.3066 38.6611 46.7207 46.247C43.1253 49.8427 38.4188 48.7693 32.9702 47.5036C33.2487 48.7006 33.5283 49.9065 33.7541 51.1016C38.965 52.2632 44.6211 53.0593 49.077 48.6034C58.3918 39.2882 44.8622 25.4275 52.4454 17.8443Z'
        fill='#FFBF14'
      />
      <path
        d='M33.754 51.1014C34.3774 51.2403 35.0068 51.3742 35.6396 51.494C35.4264 50.3019 35.1586 49.1216 34.8847 47.9402C34.2576 47.8025 33.619 47.6541 32.9697 47.5034C33.2482 48.6997 33.5267 49.8983 33.754 51.1014Z'
        fill='#E0A812'
      />
      <path
        d='M47.9769 32.496C47.6992 31.3036 47.4166 30.081 47.193 28.8984C41.9821 27.7368 36.3261 26.9407 31.8701 31.3966C22.5985 40.6687 36.0591 54.5984 28.5018 62.1557C27.851 62.8061 27.851 63.8613 28.5018 64.5117C29.1526 65.1625 30.2073 65.1625 30.8577 64.5117C40.2079 55.1618 26.6005 41.3786 34.2265 33.753C37.8222 30.1573 42.5284 31.2307 47.9769 32.496Z'
        fill='#45748C'
      />
      <path
        d='M47.1932 28.8984C46.555 28.7561 45.9107 28.6195 45.2622 28.4971C45.4671 29.6861 45.7295 30.866 46.0023 32.0463C46.6489 32.1878 47.3076 32.3404 47.9771 32.496C47.6994 31.3035 47.4167 30.0809 47.1932 28.8984Z'
        fill='#3A6175'
      />
      <path
        d='M64.9859 28.0284C64.3351 27.3776 63.2804 27.3776 62.6296 28.0284C59.4546 31.2033 55.4133 30.7376 50.7598 29.7141C51.026 30.9233 51.3129 32.1029 51.5753 33.2805C56.7221 34.2536 61.2845 34.0857 64.9859 30.3843C65.6363 29.7339 65.6363 28.6788 64.9859 28.0284Z'
        fill='#45748C'
      />
      <path
        d='M52.6065 30.0899C52.0026 29.9796 51.3865 29.8518 50.7598 29.7141C51.026 30.9234 51.3129 32.1029 51.5753 33.2805C52.1826 33.3953 52.793 33.4975 53.4045 33.5795C53.1569 32.4508 52.8689 31.2594 52.6065 30.0899Z'
        fill='#3A6175'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_17709'>
        <rect width='50' height='50' fill='white' transform='translate(15.5713 15)' />
      </clipPath>
    </defs>
  </svg>
));
MedicalGeneticsIcon.displayName = 'MedicalGeneticsIcon';

export default MedicalGeneticsIcon;
